import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
export class HomeComponent {
    constructor(authService) {
        this.authService = authService;
        this.disabled = false;
    }
    ngOnInit() {
        this.getInfoTotem();
    }
    getInfoTotem() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.authService.parametrosTotem();
            if (response) {
                localStorage.setItem('cbNombreTotem', response['nombreTotem']);
                localStorage.setItem('cbSucursal', response['sucursal']);
            }
        });
    }
    getAuthorization(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
        });
    }
}
